import React, { memo } from "react"

import { Toggle } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { bool, func } from "prop-types"

import useTranslation from "Pods/ThreeDStudio/Hooks/useTranslation"

function VisibilityToggle({ isChecked = false, onChange: handleChange }) {
  const t = useTranslation()

  return (
    <Toggle
      id="environment-settings-show-hdri"
      label={t('viewer.environment.showHdri')}
      className="environment-settings__toggle"
      isChecked={isChecked}
      onChange={event => handleChange(event.target.checked)}
    />
  )
}

VisibilityToggle.propTypes = {
  isChecked: bool,
  onChange: func.isRequired,
}

export default memo(VisibilityToggle)
